import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../analytics/posthog';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    const pageName = getPageName(location.pathname);
    trackPageView(pageName, {
      path: location.pathname,
      search: location.search,
      full_url: window.location.href,
    });
  }, [location]);
};

// Helper function to get human-readable page names
const getPageName = (pathname: string): string => {
  if (pathname === '/') return 'Landing Page';
  if (pathname === '/home') return 'Home';
  if (pathname === '/dashboard') return 'Dashboard';
  if (pathname === '/login') return 'Login';
  if (pathname === '/billing') return 'Billing';
  if (pathname === '/profile') return 'Profile';
  if (pathname.startsWith('/analysis/')) return 'Pitch Analysis';
  if (pathname.startsWith('/summary/')) return 'Pitch Summary';
  if (pathname.startsWith('/valuation/')) return 'Valuation';
  if (pathname.startsWith('/founders/')) return 'Founders Analysis';
  if (pathname.startsWith('/market-research/')) return 'Market Research';
  if (pathname.startsWith('/presentation/')) return 'Presentation Analysis';
  if (pathname.startsWith('/dataroom/')) return 'Data Room';
  if (pathname.startsWith('/investment-memo/')) return 'Investment Memo';
  if (pathname.startsWith('/webrtc-interview/')) return 'Video Interview';
  
  // Default to the pathname without leading slash
  return pathname.slice(1) || 'Unknown Page';
};